// extracted by mini-css-extract-plugin
export default {"l_DetailPageComfirmBtnContainer_main":"DetailPageComfirmBtnContainer_l_DetailPageComfirmBtnContainer_main__tFWvo"};